import axios from 'axios'

const WarehouseService = {
  async get (params = {}) {
    return axios.get('admin/warehouses', { params })
  },

  async import (params = {}) {
    return axios.post('admin/utilities/import-warehouses', params)
  },

  async sync (params = {}) {
    return axios.post('admin/utilities/sync-warehouses', params)
  },

  async post (params = {}) {
    return axios.post('admin/warehouses', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`admin/warehouses/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`admin/warehouses/${data.id}`, { data })
  }
}

export default WarehouseService
